import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ReportReady({
  exportUrl,
  resetUrl,
  isPdf,
}: {
  exportUrl: string;
  resetUrl: () => void;
  isPdf: boolean;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component
      open={!!exportUrl}
      onOpenChange={(open) => {
        if (!open) {
          resetUrl();
        }
      }}
    >
      <Content>
        <Header
          title="Your report is ready"
          subtitle={
            isPdf
              ? "Click the button below to open your report"
              : "Click the button below to download your report in CSV format"
          }
        />
        <Footer className="justify-end">
          <Button
            onClick={() => {
              resetUrl();
              window.open(exportUrl);
            }}
          >
            {isPdf ? "Open" : "Download"}
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
